"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = TableCellResizerPlugin;
// import {
//   $getTableColumnIndexFromTableCellNode,
//   $getTableNodeFromLexicalNodeOrThrow,
//   $getTableRowIndexFromTableCellNode,
//   $isTableCellNode,
//   $isTableRowNode,
//   $isTableSelection,
//   getDOMCellFromTarget,
//   TableCellNode,
// } from '@lexical/table';
// import {
//   $getNearestNodeFromDOMNode,
//   $getSelection,
//   COMMAND_PRIORITY_HIGH,
//   SELECTION_CHANGE_COMMAND,
// } from 'lexical';
var React = __importStar(require("react"));
var react_1 = require("react");
var react_dom_1 = require("react-dom");
var index_styled_1 = require("./index.styled");
var MIN_ROW_HEIGHT = 33;
var MIN_COLUMN_WIDTH = 50;
function TableCellResizer(_a) {
    var $getTableColumnIndexFromTableCellNode = _a.$getTableColumnIndexFromTableCellNode, $getTableNodeFromLexicalNodeOrThrow = _a.$getTableNodeFromLexicalNodeOrThrow, $getTableRowIndexFromTableCellNode = _a.$getTableRowIndexFromTableCellNode, $isTableCellNode = _a.$isTableCellNode, $isTableRowNode = _a.$isTableRowNode, $isTableSelection = _a.$isTableSelection, getDOMCellFromTarget = _a.getDOMCellFromTarget, $getNearestNodeFromDOMNode = _a.$getNearestNodeFromDOMNode, $getSelection = _a.$getSelection, COMMAND_PRIORITY_HIGH = _a.COMMAND_PRIORITY_HIGH, TableCellNode = _a.TableCellNode, SELECTION_CHANGE_COMMAND = _a.SELECTION_CHANGE_COMMAND, editor = _a.editor;
    var targetRef = (0, react_1.useRef)(null);
    var resizerRef = (0, react_1.useRef)(null);
    var tableRectRef = (0, react_1.useRef)(null);
    var mouseStartPosRef = (0, react_1.useRef)(null);
    var _b = (0, react_1.useState)(null), mouseCurrentPos = _b[0], updateMouseCurrentPos = _b[1];
    var _c = (0, react_1.useState)(null), activeCell = _c[0], updateActiveCell = _c[1];
    var _d = (0, react_1.useState)(false), isSelectingGrid = _d[0], updateIsSelectingGrid = _d[1];
    var _e = (0, react_1.useState)(null), draggingDirection = _e[0], updateDraggingDirection = _e[1];
    (0, react_1.useEffect)(function () {
        return editor.registerCommand(SELECTION_CHANGE_COMMAND, function (payload) {
            var selection = $getSelection();
            var isTableSelection = $isTableSelection(selection);
            if (isSelectingGrid !== isTableSelection) {
                updateIsSelectingGrid(isTableSelection);
            }
            return false;
        }, COMMAND_PRIORITY_HIGH);
    });
    var resetState = (0, react_1.useCallback)(function () {
        updateActiveCell(null);
        targetRef.current = null;
        updateDraggingDirection(null);
        mouseStartPosRef.current = null;
        tableRectRef.current = null;
    }, []);
    (0, react_1.useEffect)(function () {
        var onMouseMove = function (event) {
            setTimeout(function () {
                var target = event.target;
                if (draggingDirection) {
                    updateMouseCurrentPos({
                        x: event.clientX,
                        y: event.clientY,
                    });
                    return;
                }
                if (resizerRef.current && resizerRef.current.contains(target)) {
                    return;
                }
                if (targetRef.current !== target) {
                    targetRef.current = target;
                    var cell_1 = getDOMCellFromTarget(target);
                    if (cell_1 && activeCell !== cell_1) {
                        editor.update(function () {
                            var tableCellNode = $getNearestNodeFromDOMNode(cell_1.elem);
                            if (!tableCellNode) {
                                throw new Error('TableCellResizer: Table cell node not found.');
                            }
                            var tableNode = $getTableNodeFromLexicalNodeOrThrow(tableCellNode);
                            var tableElement = editor.getElementByKey(tableNode.getKey());
                            if (!tableElement) {
                                throw new Error('TableCellResizer: Table element not found.');
                            }
                            targetRef.current = target;
                            tableRectRef.current = tableElement.getBoundingClientRect();
                            updateActiveCell(cell_1);
                        });
                    }
                    else if (cell_1 == null) {
                        resetState();
                    }
                }
            }, 0);
        };
        document.addEventListener('mousemove', onMouseMove);
        return function () {
            document.removeEventListener('mousemove', onMouseMove);
        };
    }, [activeCell, draggingDirection, editor, resetState]);
    var isHeightChanging = function (direction) {
        if (direction === 'bottom') {
            return true;
        }
        return false;
    };
    var updateRowHeight = (0, react_1.useCallback)(function (newHeight) {
        if (!activeCell) {
            throw new Error('TableCellResizer: Expected active cell.');
        }
        editor.update(function () {
            var tableCellNode = $getNearestNodeFromDOMNode(activeCell.elem);
            if (!$isTableCellNode(tableCellNode)) {
                throw new Error('TableCellResizer: Table cell node not found.');
            }
            var tableNode = $getTableNodeFromLexicalNodeOrThrow(tableCellNode);
            var tableRowIndex = $getTableRowIndexFromTableCellNode(tableCellNode);
            var tableRows = tableNode.getChildren();
            if (tableRowIndex >= tableRows.length || tableRowIndex < 0) {
                throw new Error('Expected table cell to be inside of table row.');
            }
            var tableRow = tableRows[tableRowIndex];
            if (!$isTableRowNode(tableRow)) {
                throw new Error('Expected table row');
            }
            tableRow.setHeight(newHeight);
        });
    }, [activeCell, editor]);
    var updateColumnWidth = (0, react_1.useCallback)(function (newWidth) {
        if (!activeCell) {
            throw new Error('TableCellResizer: Expected active cell.');
        }
        editor.update(function () {
            var tableCellNode = $getNearestNodeFromDOMNode(activeCell.elem);
            if (!$isTableCellNode(tableCellNode)) {
                throw new Error('TableCellResizer: Table cell node not found.');
            }
            var tableNode = $getTableNodeFromLexicalNodeOrThrow(tableCellNode);
            var tableColumnIndex = $getTableColumnIndexFromTableCellNode(tableCellNode);
            var tableRows = tableNode.getChildren();
            for (var r = 0; r < tableRows.length; r++) {
                var tableRow = tableRows[r];
                if (!$isTableRowNode(tableRow)) {
                    throw new Error('Expected table row');
                }
                var rowCells = tableRow.getChildren();
                var rowCellsSpan = rowCells.map(function (cell) { return cell.getColSpan(); });
                var aggregatedRowSpans = rowCellsSpan.reduce(function (rowSpans, cellSpan) {
                    var _a;
                    var previousCell = (_a = rowSpans[rowSpans.length - 1]) !== null && _a !== void 0 ? _a : 0;
                    rowSpans.push(previousCell + cellSpan);
                    return rowSpans;
                }, []);
                var rowColumnIndexWithSpan = aggregatedRowSpans.findIndex(function (cellSpan) { return cellSpan > tableColumnIndex; });
                if (rowColumnIndexWithSpan >= rowCells.length ||
                    rowColumnIndexWithSpan < 0) {
                    throw new Error('Expected table cell to be inside of table row.');
                }
                var tableCell = rowCells[rowColumnIndexWithSpan];
                if (!$isTableCellNode(tableCell)) {
                    throw new Error('Expected table cell');
                }
                tableCell.setWidth(newWidth);
            }
        });
    }, [activeCell, editor]);
    var mouseUpHandler = (0, react_1.useCallback)(function (direction) {
        var handler = function (event) {
            event.preventDefault();
            event.stopPropagation();
            if (!activeCell) {
                throw new Error('TableCellResizer: Expected active cell.');
            }
            if (mouseStartPosRef.current) {
                var _a = mouseStartPosRef.current, x = _a.x, y = _a.y;
                if (activeCell === null) {
                    return;
                }
                if (isHeightChanging(direction)) {
                    var height = activeCell.elem.getBoundingClientRect().height;
                    var heightChange = Math.abs(event.clientY - y);
                    var isShrinking = direction === 'bottom' && y > event.clientY;
                    updateRowHeight(Math.max(isShrinking ? height - heightChange : heightChange + height, MIN_ROW_HEIGHT));
                }
                else {
                    var computedStyle = getComputedStyle(activeCell.elem);
                    var width = activeCell.elem.clientWidth; // width with padding
                    width -=
                        parseFloat(computedStyle.paddingLeft) +
                            parseFloat(computedStyle.paddingRight);
                    var widthChange = Math.abs(event.clientX - x);
                    var isShrinking = direction === 'right' && x > event.clientX;
                    updateColumnWidth(Math.max(isShrinking ? width - widthChange : widthChange + width, MIN_COLUMN_WIDTH));
                }
                resetState();
                document.removeEventListener('mouseup', handler);
            }
        };
        return handler;
    }, [activeCell, resetState, updateColumnWidth, updateRowHeight]);
    var toggleResize = (0, react_1.useCallback)(function (direction) {
        return function (event) {
            event.preventDefault();
            event.stopPropagation();
            if (!activeCell) {
                throw new Error('TableCellResizer: Expected active cell.');
            }
            mouseStartPosRef.current = {
                x: event.clientX,
                y: event.clientY,
            };
            updateMouseCurrentPos(mouseStartPosRef.current);
            updateDraggingDirection(direction);
            document.addEventListener('mouseup', mouseUpHandler(direction));
        };
    }, [activeCell, mouseUpHandler]);
    var getResizers = (0, react_1.useCallback)(function () {
        if (activeCell) {
            var _a = activeCell.elem.getBoundingClientRect(), height = _a.height, width = _a.width, top_1 = _a.top, left = _a.left;
            var styles = {
                bottom: {
                    backgroundColor: 'none',
                    cursor: 'row-resize',
                    height: '10px',
                    left: "".concat(window.pageXOffset + left, "px"),
                    top: "".concat(window.pageYOffset + top_1 + height, "px"),
                    width: "".concat(width, "px"),
                },
                right: {
                    backgroundColor: 'none',
                    cursor: 'col-resize',
                    height: "".concat(height, "px"),
                    left: "".concat(window.pageXOffset + left + width, "px"),
                    top: "".concat(window.pageYOffset + top_1, "px"),
                    width: '10px',
                },
            };
            var tableRect = tableRectRef.current;
            if (draggingDirection && mouseCurrentPos && tableRect) {
                if (isHeightChanging(draggingDirection)) {
                    styles[draggingDirection].left = "".concat(window.pageXOffset + tableRect.left, "px");
                    styles[draggingDirection].top = "".concat(window.pageYOffset + mouseCurrentPos.y, "px");
                    styles[draggingDirection].height = '3px';
                    styles[draggingDirection].width = "".concat(tableRect.width, "px");
                }
                else {
                    styles[draggingDirection].top = "".concat(window.pageYOffset + tableRect.top, "px");
                    styles[draggingDirection].left = "".concat(window.pageXOffset + mouseCurrentPos.x, "px");
                    styles[draggingDirection].width = '3px';
                    styles[draggingDirection].height = "".concat(tableRect.height, "px");
                }
                styles[draggingDirection].backgroundColor = '#adf';
            }
            return styles;
        }
        return {
            bottom: null,
            left: null,
            right: null,
            top: null,
        };
    }, [activeCell, draggingDirection, mouseCurrentPos]);
    var resizerStyles = getResizers();
    return (React.createElement("div", { ref: resizerRef }, activeCell != null && !isSelectingGrid && (React.createElement(React.Fragment, null,
        React.createElement(index_styled_1.StyledTableCellResizer, { className: "TableCellResizer__resizer TableCellResizer__ui", style: resizerStyles.right || undefined, onMouseDown: toggleResize('right') }),
        React.createElement(index_styled_1.StyledTableCellResizer, { className: "TableCellResizer__resizer TableCellResizer__ui", style: resizerStyles.bottom || undefined, onMouseDown: toggleResize('bottom') })))));
}
function TableCellResizerPlugin(_a) {
    var useLexicalComposerContext = _a.useLexicalComposerContext, useLexicalEditable = _a.useLexicalEditable, $getTableColumnIndexFromTableCellNode = _a.$getTableColumnIndexFromTableCellNode, $getTableNodeFromLexicalNodeOrThrow = _a.$getTableNodeFromLexicalNodeOrThrow, $getTableRowIndexFromTableCellNode = _a.$getTableRowIndexFromTableCellNode, $isTableCellNode = _a.$isTableCellNode, $isTableRowNode = _a.$isTableRowNode, $isTableSelection = _a.$isTableSelection, getDOMCellFromTarget = _a.getDOMCellFromTarget, $getNearestNodeFromDOMNode = _a.$getNearestNodeFromDOMNode, $getSelection = _a.$getSelection, TableCellNode = _a.TableCellNode, COMMAND_PRIORITY_HIGH = _a.COMMAND_PRIORITY_HIGH, SELECTION_CHANGE_COMMAND = _a.SELECTION_CHANGE_COMMAND;
    var editor = useLexicalComposerContext()[0];
    var isEditable = useLexicalEditable();
    return (0, react_1.useMemo)(function () {
        return isEditable
            ? (0, react_dom_1.createPortal)(React.createElement(TableCellResizer, { $getTableColumnIndexFromTableCellNode: $getTableColumnIndexFromTableCellNode, $getTableNodeFromLexicalNodeOrThrow: $getTableNodeFromLexicalNodeOrThrow, $getTableRowIndexFromTableCellNode: $getTableRowIndexFromTableCellNode, $isTableCellNode: $isTableCellNode, $isTableRowNode: $isTableRowNode, $isTableSelection: $isTableSelection, getDOMCellFromTarget: getDOMCellFromTarget, $getNearestNodeFromDOMNode: $getNearestNodeFromDOMNode, $getSelection: $getSelection, COMMAND_PRIORITY_HIGH: COMMAND_PRIORITY_HIGH, SELECTION_CHANGE_COMMAND: SELECTION_CHANGE_COMMAND, TableCellNode: TableCellNode, editor: editor }), document.body)
            : null;
    }, [editor, isEditable]);
}
